import React, { useEffect, useState } from 'react';
import './ContactPage.css';
import { parseSpecialMarkup } from '../utils/typography';

export default function ContactPage({ language = 'en' }) {
  const [contactInfo, setContactInfo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/descriptions/98-Contact.json')
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load contact info');
        return response.json();
      })
      .then((data) => setContactInfo(data[0]))
      .catch((err) => setError(err.message));
  }, []);

  // Use the user's provided Google Form embed link for embedding
  // Provided: https://docs.google.com/forms/d/e/1FAIpQLSehEylbsR8jTYHrKuX4FBP9JeNvisg4v6b6bIZrshosNQs5yA/viewform?usp=dialog
  // For iframe, use .../viewform?embedded=true&hl=en (or hl=pl)
  let googleFormUrl =
  language === 'pl'
    ? 'https://docs.google.com/forms/d/e/1FAIpQLSdVgcNyPE66y5aG1YWUqUhLCqAPCo3va3__IbixLFiAuChiNw/viewform?embedded=true&hl=pl'
    : `https://docs.google.com/forms/d/e/1FAIpQLSehEylbsR8jTYHrKuX4FBP9JeNvisg4v6b6bIZrshosNQs5yA/viewform?embedded=true&hl=${language}`;
  return (
    <div style={{ padding: '2.5rem 0 1.5rem 0', minHeight: '60vh', background: '#f8fafd' }}>
      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
      {contactInfo ? (
        <div className="contact-inquiry-flex">
          <div className="contact-info-card">
            <h1 className="contact-info-card-title">{contactInfo.title?.[language] || contactInfo.title?.en || 'Contact information'}</h1>
            {contactInfo.subtitle && (
              <div className="contact-info-card-subtitle">
                {Object.keys(contactInfo.subtitle)
                  .filter(key => key.startsWith(language))
                  .sort((a, b) => {
                    // ensure main key (e.g. 'en') comes first, then 'en1', 'en2', ...
                    if (a === language) return -1;
                    if (b === language) return 1;
                    return a.localeCompare(b, undefined, { numeric: true });
                  })
                  .map(key => (
                    <div key={key}>{contactInfo.subtitle[key]}</div>
                  ))}
                {/* Fallback to English if nothing for current language */}
                {(!Object.keys(contactInfo.subtitle).some(key => key.startsWith(language))) &&
                  Object.keys(contactInfo.subtitle)
                    .filter(key => key.startsWith('en'))
                    .sort((a, b) => {
                      if (a === 'en') return -1;
                      if (b === 'en') return 1;
                      return a.localeCompare(b, undefined, { numeric: true });
                    })
                    .map(key => (
                      <div key={key}>{contactInfo.subtitle[key]}</div>
                    ))}
              </div>
            )}
            <div className="contact-info-card-text">
              {Object.keys(contactInfo.description)
                .filter((key) => key.startsWith(language))
                .map((key) => (
                  contactInfo.description[key]
                    ? <p key={key} dangerouslySetInnerHTML={{ __html: parseSpecialMarkup(contactInfo.description[key]) }} />
                    : null
                ))}
            </div>
          </div>
          <div className="contact-inquiry-form">
            <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
              <iframe
                title="Google Form"
                src={googleFormUrl}
                width="100%"
                style={{ border: 'none', flex: 1, minHeight: 0, height: '100%' }}
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
              >
                Loading…
              </iframe>
            </div>
            <p style={{ textAlign: 'center', fontSize: '0.95em', marginTop: 8 }}>
              If the form does not load, <a href={googleFormUrl.replace('?embedded=true', '')} target="_blank" rel="noopener noreferrer">open it in a new tab</a>.
            </p>
          </div>
        </div>
      ) : !error ? (
        <p style={{ textAlign: 'center' }}>Loading contact information...</p>
      ) : null}
    </div>
  );
}
